import React, {useState, useEffect } from 'react';
// import styles from './AdvancedBasicSuperfundNPL.module.scss';
import styles from '../../../BasicCleanupsFilter/BasicCleanupsFilter.module.scss';
import { CalciteCheckbox } from '@esri/calcite-components-react';

/*
the options object stores objects with attributes for:
  - what to label the checkbox with
  - what parameter to query for when a box is checkbox
  - the objectIds returned from the query (query is only done the first time the box is checked)
*/
const options = {
  "Proposed": {
    param: "SF_NPL_CODE_ALL = 'P' AND SF_NON_NPL_CODE = ''",
    isIncluded: false,
    objectIds: null
  },
  "Final": {
    param: "SF_NPL_CODE_ALL = 'F' AND SF_NON_NPL_CODE = ''",
    isIncluded: false,
    objectIds: null
  },
  "Deleted": {
    param: "SF_NPL_CODE_ALL = 'D' AND SF_NON_NPL_CODE = ''",
    isIncluded: false,
    objectIds: null
  },
  "Superfund Sites Targeted for Immediate, Intense Action": {
    param:  "SF_ADMIN_FLAG='Y' AND SF_NON_NPL_CODE = ''",
    isIncluded: false,
    objectIds: null
  },
  "Superfund Alternative Approach (SAA) Agreement Sites": {
    param:  "SAA_SITE='Y' AND SF_NON_NPL_CODE = ''",
    isIncluded: false,
    objectIds: null
  },
  "Ready for Anticipated Use": {
      param: "SF_READY_FOR_REUSE_IND = 'Y' AND SF_NPL_CODE_ALL in ('P','A','F','D') AND SF_NON_NPL_CODE = ''",
      isIncluded: false,
      objectIds: null
  }
};

const AdvancedBasicSuperfundNPL = (props) => {
  const [checkboxDivArray, setCheckboxDivArray] = useState<Array<any>>([]);
  /* called every time a checkbox is checked or unchecked */
  const toggleParam = async (key) => {
    options[key].isIncluded = !options[key].isIncluded;
    passUpdatedParams();
  }

  // updates the brownfieldParam array stored in the parent component
  const passUpdatedParams = () => {
    let paramArray: Array<string> = [];
    for (let option in options) {
      if (options[option].isIncluded === true) {
        paramArray.push(options[option].param)
      }
    }
    // update the parameter stored in the parent component
    props.updateSuperfundNPLParams(paramArray);
  }

  const buildCheckboxDivs = (clear?) => {
    let tempArr: Array<any> = [];
    if (clear) {
      // the clear button was clicked, recreate checkboxes to be all unchecked
      for (let key in options) {
        options[key]["isIncluded"] = false;
        tempArr.push(
          <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
            <CalciteCheckbox name={options[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(key) }} />
            <label className={styles.CheckboxLabels}>{key}</label>
          </div>
        );
      }
    } else {
      for (let key in options) {
        // clear button was not clicked, create checkboxes so that previously checked are still checked
        if (options[key]["isIncluded"] === true) {
          tempArr.push(
            <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
              <CalciteCheckbox checked name={options[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(key) }} />
              <label className={styles.CheckboxLabels}>{key}</label>
            </div>
          );
        } else {
          tempArr.push(
            <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
              <CalciteCheckbox name={options[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(key) }} />
              <label className={styles.CheckboxLabels}>{key}</label>
            </div>
          );
        }
      }
    }
    passUpdatedParams();
    setCheckboxDivArray(tempArr);
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { buildCheckboxDivs(); }, [props.matchesAny]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { buildCheckboxDivs(true); }, [props.signalClear]);

  return (
    <div className={styles.Sections}>
      <div className={styles.SectionTitleDivs}>
        <label className={styles.FilterSectionLabels}>Superfund NPL Sites</label>
      </div>
      <div className={styles.CheckboxSectionDivs}>
        {checkboxDivArray}
      </div>
    </div>
  );
}
export default AdvancedBasicSuperfundNPL;

